import React, { Component } from 'react';
import './CardActivation.css';
import "../../CommonStyles/CSS.css"
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
import Aggiungi from '../../images/public/Aggiungi.png';
import tick from '../../images/public/tick.png';
import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { isBrowser } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
import { validateCard } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col, Modal, Spinner } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import TopBar from '../../assets/components/topbar/TopBar';
import miniArrow from '../../images/public/registeration/miniarrow.png';

// const stageName = "CardId";

const cookies = new Cookies();

class CardActivation extends Component {
	constructor(props) {
		super(props);

		//let params = null;
		//console.log('[CardActivation]', params);

		this.state = {
			// isLoading: false,
			step: '2',
			errmsg: null,
			errorFlg: false,
			workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
			screenData: null,
			userOptions: [],
			canProceed: false,
			helpShow: false,
			helpMessage: "",
			validating: false, // for spinner
			signal: "",
			showAddNewCardInput: false,
		};
		}

		componentDidMount() {
				// this.wf = new MPWorkFlow();
				// this.init();
				this.refresh();
		}

		// async init() {
		//     // update screenData for current states
		//     await getWorkFlow(this, stageName);
		//     this.update();
		// }

		async update() {
				// updating server state...
				let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
				if (!resp) return;
				//console.log('[CardActivation] @update #resp', resp);
				if (resp.status === "success") {
						// updating localStorage
						MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
						// updating current screen
						this.refresh();
				} /*
				else if (resp.status === "fail") {
					//this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
				} */
		}

		async refresh() {
			// update screenData for current states
			await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("CardId"));

			this.setState({ canProceed: this.state.screenData.link_next !== "" });
			//this.setState({ canProceed: false });

			// sorting user's options
			this.orderUserOptions();
		}

		async transit(toWhere) {

				let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
				console.log('[WelcomeScreen] @transit #resp', resp);

				if (resp.status === "success") {
						// updating localStorage and navigating to the new screen
						MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
						let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
						// console.log("[WelcomeScreen] @gotoResorts #getRouteName:", nextScreen);
						return this.props.history.push(nextScreen);
				} /*else if (resp.status === "fail") {
						this.setState({ errorFlg: true, errmsg: resp.message });
				}*/

		}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ errorFlg: false })
				break;
			case "actionButton":
				if (info.option1 === "attention") 
					this.setState({ errorFlg: false })
				break;
			default:
				break;
		}
	}

		/* new functions for new flow */

		// orders user's options by 'order' key inside 'options' object of screenData
		orderUserOptions() {
				// NOTE: each time an option changes, this function must be called after modifyWorkflow() call
				// order the options
				let options = Object.values(this.state.screenData.options).sort((x, y) => x.order - y.order);
				// console.log("[CardActivation] @orderUserOptions #options:", options);
				this.setState({ userOptions: options });
				// by default if there's no other cards the input is shown for the first card
				this.setState({ showAddNewCardInput: (options.length === 0) });
		}

		onUserOptionChanged = (id) => {
				let index = Number(id.split("-")[2]);
				// console.log("[CardActivation] @onUserOptionChanged #index:", index);

				// finding corresponding key in the object that matches the order index 
				let options = this.state.userOptions;
				// console.log("[CardActivation] @onUserOptionChanged #options:", options);
				let workflowOptions = this.state.screenData.options;
				// console.log("[CardActivation] @onUserOptionChanged #workflowOptions:", workflowOptions);
				const key = Object.keys(workflowOptions).find(key => workflowOptions[key].order === options[index].order);
				// console.log("[CardActivation] @onUserOptionChanged #key:", key);

				// changing options and modifying workflow
				// clearing all options and setting the selected one

				options.map(opt => {  // for current screen usage
						opt.enabled = 0;
				});
				// to update the workflow
				Object.keys(workflowOptions).map(k => { // for updating the complete w.f.
						workflowOptions[k].enabled = 0;
				})

				// setting the selected option
				options[index].enabled = 1;
				workflowOptions[key].enabled = 1;
				// console.log("[CardActivation] @onUserOptionChanged #workflowOptions:", workflowOptions);
				// console.log("[CardActivation] @onUserOptionChanged #options:", options);

				// update current screen
				this.setState({ userOptions: options });
				// updating wf
				let screenData = this.state.screenData;
				screenData.options = workflowOptions;

				this.update();

		}

		helpShowModal = (help_tag) => {
				MPWorkFlow.getInstance().workflowHelp(this, {tag: help_tag});
		}

		onBack = () => {
				//       return this.props.history.push('/');
				this.transit(this.state.screenData.link_back);
		}

		gotoNextStage = (e) => {
				e.preventDefault();
				this.transit(this.state.screenData.link_next);
		}



		validateCard = () => {
				this.setState({ signal: "" });
				let cardID = document.getElementById("card-activation-input").value;
				let noEmptySpaceCardId = cardID.replace(/ /gi, "");
				//console.log("[CardActivation] @validateCard #noEmptySpaceCardId:", noEmptySpaceCardId);
				let access_token = cookies.get('access_token');
				let params = { card_code: noEmptySpaceCardId };
				this.setState({ validating: true });
				validateCard(this, access_token, params)
						.then((response) => {
								this.setState({ validating: false });
								//console.log("[CardActivation] @validateCard #response: ", response);
								if (response.status === "success") {
										//Card can be assigned to the user.
										this.setState({ cardIsvalid: true, signal: "tick" });

										return this.addVerifiedCard(noEmptySpaceCardId);
								} else {
										this.setState({
												cardIsvalid: false,
												errorFlg: true,
												errmsg: response.message,
												signal: "cross",
										});
										//Card cannot be assigned to the user.

								}
						});
		}

		addVerifiedCard = (code) => {
				console.log("[CardActivation] @addVerifiedCard #code:", code);
				this.state.screenData.code = code;
				this.update();
		}

		onCardIDChange = () => {
				let cardID = document.getElementById("card-activation-input").value;
				let pureCardID = cardID.replace(/[^0-9a-zA-Z]/gi, "");
				// console.log("[CardActivation] @onCardIDChange #pureCardID:", pureCardID);

				const formatCardIDTypeA = () => {
						// SKIDATA(MYPASS)
						// [2, 4, 4, 4, 4, 4, 1]
						// ['-', ' ', ' ', ' ', ' ', '-']
						let formattedCardID = "";
						const idLen = pureCardID.split("").length;
						for (let index = 0; index < idLen; index++) {
								const idChar = pureCardID[index];
								switch (index) {
										case 2:
										case 22:
												formattedCardID += "-" + idChar;
												// console.log("[CardActivation] @onCardIDChange #1 || 21:", formattedCardID);
												break;
										case 6:
										case 10:
										case 14:
										case 18:
												formattedCardID += " " + idChar;
												// console.log("[CardActivation] @onCardIDChange #22:", formattedCardID);
												break;
										default:
												formattedCardID += idChar;
												// console.log("[CardActivation] @onCardIDChange #default:", formattedCardID);
												break;
								}
						}
						document.getElementById("card-activation-input").value = formattedCardID;
						if (idLen === 23) this.validateCard();
						if (idLen < 23) this.setState({ signal: "" });
				}
				const formatCardIDTypeB = () => {
						// PAGANELA
						// [8, 3, 3]
						// ['-', '-']
						let formattedCardID = "";
						const idLen = pureCardID.split("").length;
						for (let index = 0; index < idLen; index++) {
								const idChar = pureCardID[index];
								switch (index) {
										case 8:
										case 11:
										case 14:
												formattedCardID += "-" + idChar;
												// console.log("[CardActivation] @onCardIDChange #1 || 21:", formattedCardID);
												break;
										default:
												formattedCardID += idChar;
												// console.log("[CardActivation] @onCardIDChange #default:", formattedCardID);
												break;
								}
						}
						document.getElementById("card-activation-input").value = formattedCardID;
						if (idLen === 14) this.validateCard();
						if (idLen < 14) this.setState({ signal: "" });
				}

				if (pureCardID.length > 1) {
						if (pureCardID.slice(0, 2) === "01" || pureCardID.slice(0, 2) === "28" || pureCardID.slice(0, 2) === "29" || pureCardID.slice(0, 2) === "30") {
								this.setState({ cardType: 0, maxLength: 23 + 6 }); // 6 extra chars imncluding " " & "-"
								formatCardIDTypeA();
						} else {
								this.setState({ cardType: 2, maxLength: 14 + 2 }); // 2 extra chars imncluding "-"
								formatCardIDTypeB();
						}
				} else {
						this.setState({ cardType: -1, maxLength: 23 + 6 });
				}



		}

		handleAddNewCard = () => {
				this.setState({ showAddNewCardInput: true });
		}


		render() {
			//console.log('[CardActivation]', this.state);
			return (
				<Router>
				{
					this.state.screenData &&
					<div>
						<div>
							<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
								<div className="row flex-nowrap">
									<div className="col-2 d-flex align-items-center">
										<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow } alt=""/></button>
									</div>
									<div className="col-8 d-flex align-items-center justify-content-center">
										<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
									</div>
									<div className="col-2 d-flex align-items-center justify-content-end">
										<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help } alt=""/></button>
									</div>
								</div>
							</div>
							<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
							<div className="sn_overlay d-lg-none"></div>
							<div className="sn_activation">
								<div className="container">
									<div className="row">
										<div className="col-12 col-lg-10 mx-auto">
											<div className="sn_register__container">
												<div className="row d-none d-lg-flex mb-3">
													<div className="col-12 d-flex justify-content-end">
													<div className="sn_quest">
													{
														this.state.screenData && this.state.screenData.help_tag &&
														<a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
															<img src={help} alt=""/>
														</a>
													}
													</div>										
												</div>
											</div>
											{
												this.state.userOptions.map((card, index) => {
												return <ValidCard
																	key={`cardId-valid-card-key-${index}`}
																	id={`cardId-valid-card-${index}`}
																	card={card}
																/>
												})
											}
											{
											this.state.showAddNewCardInput &&
											<div>
												<div className="row mb-5">
													<div className="col-12 d-flex align-items-center flex-column">
														<h5 className="mb-4">{ this.state.screenData && HtmlWrapper(this.state.screenData.title) }</h5>
														<div className="text-input-code" style={{ borderBottomColor: this.state.signal === "cross" ? "rgb(247, 192, 192)" : "white" }}>
															<input
																disabled={this.state.validating}
																type="text"
																id="card-activation-input"
																className="card-activation-input"
																placeholder={this.state.screenData ? this.state.screenData.code_pholder : ""}
																maxLength={this.state.maxLength}
																onChange={this.onCardIDChange}
																style={{ color: this.state.signal === "cross" ? "rgb(247, 192, 192)" : "white" }}
															/>
															<div className="wrap-state">
															{ this.state.validating && <Spinner animation="border" variant="light" /> }
															{
																this.state.signal === "tick" &&
																<div className="wrap-tick">
																	<img src={tick} alt=""/>
																</div>
															}
															{   
																this.state.signal === "cross" &&
																<div className="wrap-tick" style={{ color: "rgb(247, 192, 192)" }}>
																✘
																</div>
															}
															</div>
														</div>
													</div>
												</div>
											</div>
										}
										{
											!this.state.showAddNewCardInput &&
											<div className="row">
												<div className="col-12">
													<div onClick={this.handleAddNewCard} className={isBrowser ? "cardid-add-new-rectangle" : "cardid-add-new-rectangle-mob"}>
														<div className="cardid-add-new-container">
															<img src={Aggiungi} className="cardid-add-new-icon" alt=""/>
															{HtmlWrapper(this.state.screenData.add_card)}
														</div>
													</div>
												</div>
											</div>
										}
										{
											this.state.screenData.useful_info_title &&
											<div className="row mt-5">
												<div className="col-12">
													<h5>{ HtmlWrapper(this.state.screenData.useful_info_title) }</h5>
													<p>{ HtmlWrapper(this.state.screenData.useful_info) }</p>
												</div>
											</div>
										}
										<div className="row mt-5">
											<div className="col-12 d-flex justify-content-center">
												<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
												<button disabled={ !this.state.canProceed } className="sn_btn" onClick={ this.gotoNextStage }>{ this.state.screenData.next_button }</button>
											</div>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
							{
								this.state.errorFlg ?
								<div className="containerModal">
								{
									this.state.errorFlg ?
									<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
								}
								</div> : null
							}
						</div>
						<WaitLoad enable={ this.state.workFlowInProgress } />
						{ this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
					</div>
				}
				</Router>
		);
	}
}

export default CardActivation;


class ValidCard extends React.Component {
	render() {
		const { card } = this.props;
			return (
				<div className="row justify-content-center">
					<div className="col-12">
						<div className="sn_activation__container__inner p-4 mb-5">
							<div className="row mb-2">
								<div className="col-12 d-flex justify-content-end">
									<div className="sn_underline">
										<div onClick={() => null}>
											{(tr.t("Delete"))}
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-4">
								<div className="col-12">
										<div className="cardid-valid-card-and-label-container">
											<img src={card.icon} className="cardid-valid-card-icon mb-2" alt=""/>
											<h6>{ HtmlWrapper(card.label) }</h6>
										</div>
									</div>
								</div>
								<div className="row mb-3">
									<div className="col-12 d-flex justify-content-center">
										<div className="text-input-code">
											<input
												disabled={true}
												type="text"
												id={"activated-card-input"+this.props.id}
												className="card-activation-input"
												defaultValue={card.code}
											/>
											<div className="wrap-tick">
												<img src={tick} alt=""/>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<h5 className="text-center">{ HtmlWrapper(card.desc) }</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
			)
		}
}


// WEBPACK FOOTER //
// ./src/screens/CardActivation/CardActivation.js